import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Camera, Smile, TrendingUp } from 'lucide-react';
const moments = [{
  icon: Heart,
  title: 'Convidados elogiando',
  description: '"Que lembrancinha linda!" E você sorrindo, sabendo que custou centavos.'
}, {
  icon: Camera,
  title: 'Fotos perfeitas',
  description: 'Lembrancinhas lindas nas fotos. Detalhes que você vai querer mostrar.'
}, {
  icon: Smile,
  title: 'Sensação de orgulho',
  description: 'Você olha e sente orgulho genuíno. Você fez. E ficou lindo.'
}, {
  icon: TrendingUp,
  title: 'Economia gigantesca',
  description: 'Gastou R$200 em vez de R$2.000. Ninguém percebeu a diferença.'
}];
export function FuturePacingSection() {
  return <section className="py-12 md:py-20 bg-gradient-to-br from-amber-50 via-yellow-50 to-stone-50" data-id="element-84">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-86">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-stone-900 mb-4 md:mb-6" data-id="element-87">
            Imagine o Dia do Seu Casamento Assim...
          </h2>
          <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto" data-id="element-88">
            Feche os olhos por um momento e visualize essa cena:
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-89">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-4 md:p-6 rounded-xl md:rounded-2xl shadow-lg text-center" data-id="element-90">
              <div className="bg-gradient-to-br from-amber-100 to-yellow-100 w-12 h-12 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4" data-id="element-91">
                <moment.icon className="w-6 h-6 md:w-8 md:h-8 text-amber-600" data-id="element-92" />
              </div>
              <h3 className="text-base md:text-lg font-bold text-stone-900 mb-2 md:mb-3" data-id="element-93">
                {moment.title}
              </h3>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed" data-id="element-94">
                {moment.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}